/* istanbul ignore file */
import React from 'react';
import { useLeaveUrl } from 'domain/people/leave/leaveRouting';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const LeavesBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { getListUrl } = useLeaveUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Leaves" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default LeavesBreadcrumbs;
